import { AlertTitle, Typography } from '@mui/material';
import { FC } from 'react';

type Props = {
  title: string;
};

export const FeedbackAlertTitle: FC<Props> = ({ title }) => {
  return (
    <AlertTitle
      sx={{
        marginBottom: 0
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          marginTop: '0.15rem',
          lineHeight: '1.5rem',
          color: 'midnight.dark',
          fontWeight: '500',
          fontSize: '14px'
        }}
      >
        {title}
      </Typography>
    </AlertTitle>
  );
};
